export default {
    name: 'proposals',
    component: () => import('../../../layouts/ProjectsLayout.vue'),
    meta : {requiresAuth : true, allowedUserTypes: [ 4 ]},
    children: [
        {
            name: 'proposalsView',
            path: '', // Default child route
            component: () => import('@/modules/proposalsModule/views/ProposalsView.vue'), // Component to be shown by default
        },
    ]
}